export default "__VITE_ASSET__DZyK7TKu__"